import Vue from 'vue';
import VueRouter from 'vue-router';
import About from '@/views/About.vue';
import Contact from '@/views/Contact.vue';
import References from '@/views/References.vue';
import Technology from '@/views/Technology.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: About,
  },
  {
    path: '/o-nas',
    name: 'About',
    component: About,
  },
  {
    path: '/kontakty',
    name: 'Contact',
    component: Contact,
  },
  {
    path: '/reference',
    name: 'References',
    component: References,
  },
  {
    path: '/technika',
    name: 'Technology',
    component: Technology,
  },
  {
    path: '*',
    component: About,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
